import React, { Component } from "react";
import { Container, Row, Col, Jumbotron, Card, CardImg } from "reactstrap";

import QuestionForm from "./QuestionForm";

import "./style.css";
import { Helmet } from "react-helmet";

class AboutUsPage extends Component {
  render() {
    return (
      <div className="all-pages">
            <Helmet>
          <meta charSet="utf-8" />
          <title>Lighthouse</title>
          <link rel="canonical" href="http://atlighthouse.com" />

          <meta property="og:type" content="website" />
          <meta property="og:title" content="Lighthouse"></meta>
          <meta property="og:description" content="Be on a high-growth tech-career with project-based experiential learning, dedicated mentoring and career coaching."></meta>
          <meta property="og:url" content="https://atlighthouse.com"></meta>
          <meta name="twitter:card" content="summary_large_image"></meta>
          <meta name="twitter:site" content="@at_lighthouse"></meta>
          <meta name="twitter:title" content="Lighthouse"></meta>
          <meta name="twitter:description" content="Be on a high-growth tech-career with project-based experiential learning, dedicated mentoring and career coaching."></meta>
          <meta name="twitter:url" content="https://atlighthouse.com"></meta>
          <meta
            name="description"
            content="Be on a high-growth tech-career with project-based experiential learning, dedicated mentoring and career coaching."
          />
  
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, shrink-to-fit=no"
          />
          <meta
            name="keywords"
            content="Coding Bootcamps, Technology Bootcamps, Tech bootcamps, Business and technology bootcamps, 
              Business bootcamps, Bootcamp, Programming, Become a Developer, Become a Software Developer, Learn Code,
              Get Hired for coding, Immersive program, Intensive program, Atlanta Coding bootcamps, Best coding bootcamps,Top coding bootcamps in Atlanta, Free coding bootcamp, Job guarantee bootcamp, Bootcamp with job guarantee,
              Steps to becoming a developer, Steps to becoming a web developer, Steps to becoming a software engineer, How to become a developer, How to become a programmer, How to become a web developer, How to become a full stack web developer, How to become a full stack developer, How to become a software developer, How to become a software engineer, How to become a data scientist, How to become a data analyst, How to become a digital marketer, How to become a UX designer, How to become an experience designer, How to become a UI designer, Coding bootcamp with job guarantee, Full time coding bootcamps, Part time coding bootcamps, Learn full stack web development, Learn web development, Learn software engineering, Learn data science, Learn data analytics, Learn digital marketing, Learn experience design, Learn ux design, Learn ui design, Full Stack Web Development Course, Full Stack Web Development Bootcamp, Full Stack Web Development Program, Full Stack Web Development Certificate, Atlanta Full Stack Development Course, Atlanta Full Stack Development Bootcamp, Atlanta Full Stack Development Program, Atlanta Full Stack Development Certificate, Data Science Course, Data Science Bootcamp, Data Science Program, Data Science Certificate, Atlanta Data Science Course, Atlanta Data Science Bootcamp, Atlanta Data Science Program, Atlanta Data Science Certificate, Software Engineering Course, Software Engineering Bootcamp, Software Engineering Program, Software Engineering Certificate, Atlanta Software Engineering Course, Atlanta Software Engineering Bootcamp, Atlanta Software Engineering Program, Atlanta Software Engineering Certificate, Digital Marketing Course, Digital Marketing Bootcamp, Digital Marketing Program, Digital Marketing Certificate, Atlanta Digital Marketing Course, Atlanta Digital Marketing Bootcamp, Atlanta Digital Marketing Program, Atlanta Digital Marketing Certificate, UX Course, UX Certificate, UX Bootcamp, UX Program, Atlanta UX Course, Atlanta UX Certificate, Atlanta UX Bootcamp, Atlanta UX Program, Competitive programming, How to get a job in programming, Bootcamps for college students, Coding bootcamps for college students, Best coding bootcamps in atlanta, Top rated coding bootcamps in atlanta, Top rated coding bootcamps, Best coding bootcamps, Rigorous coding bootcamps, Data Science bootcamps for college students, Best Data Science bootcamps in atlanta, Top rated Data Science bootcamps in atlanta, Top rated Data Science bootcamps, Best Data Science bootcamps, Can you get a job out of a coding bootcamp?, Talent Marketplace, Technology skills, Technology career, Career in software engineering, Career in data science, Career in digital marketing, Career in ux design, Career, Learn, Programming, Coding, Machine learning courses, Web development courses"
          />
          <meta name="theme-color" content="#000000" />
        </Helmet>
        <Jumbotron className="jumbos about-us-jumbo text-left mb-0 mb-md-3" fluid>
          <Container>
            <Row className="justify-content-center justify-content-md-start">
              <Col className="pt-5 pt-md-5" xs={{ size: 12 }} sm={{ size: 10 }} md={{ size: 6, offset: 1 }}>
                <h1 className="pt-md-5 pt-sm-2">It's Lighthouse.</h1>
                <p className="pt-2">
                  Inspired by the enlightenment comes as one learns something new. We believe that everyone has the potential to grow, learn, and get better opportunities.

                  You can be the light that makes Atlanta's tech community forward to higher possibilities. You are the light in the house.
                </p>
              </Col>
            </Row>
          </Container>
          
        </Jumbotron>
        <Container className="section-padding">

          <Row className="justify-content-center justify-content-lg-start pt-2 pt-md-5">
            <Col xs={{ size: 11 }} sm={{ size: 10 }} lg={{ size: 6, offset: 1 }}>
              <h1 className="text-left mt-lg-5 mb-3 mb-lg-5">
                We're Very Passionate <br />About Helping People
                </h1>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col
              xs={{ size: 11, order: 1 }}
              sm={{ size: 10, order: 1 }}
              lg={{ size: 5, order: 1 }}
              className=" pr-lg-5"
            >
              <p className="text-left">
                Lighthouse, founded by a team with decades of experience in the technology industry, is a skill accelerated talent marketplace and education institution headquartered and started in Atlanta, GA.
                <br /><br />
                Cities grow and develop with help from the people who work and live in them. So cities thrive on job creation, especially on tech job creation today. Our biggest mission is in creating an economically inclusive workforce. And we do that by developing digital-ready tech talent.
                <br /><br />
                With our curiosity in human potential and belief that by providing the right skills and tools, anyone has the potential to build the technology career they want to stay relevant, forever.
                  </p>
            </Col>
            <Col
              xs={{ size: 11, order: 2 }}
              sm={{ size: 10, order: 2 }}
              lg={{ size: 5, order: 2 }}
              className=""
            >
              <Card className="about-us-img our-story-img-transform">
                <CardImg
                  top
                  height="100%"
                  src="img/about-us-img-v2.png"
                  alt="Card image cap"
                  style={{ borderRadius: "0" }}
                />
              </Card>
            </Col>
          </Row>

        </Container>
        <Row className="justify-content-center section-padding">
          <Col xs={{ size: 12 }} sm={{ size: 12 }} className="text-center">
            <div className='position-relative'>
              <h1 className="mt-5 mb-3 pb-2 center-h1 course-path">
                How We Help You
              </h1>
            </div>
            
            {/* <hr className="heading-underline1" /> */}
            <Col sm={{ size: 8, offset: 2 }}>
              <p className="">
                With the work landscape rapidly changing, it’s easy to feel sidelined before you even start. Our expert instructors are with you at every step.
              </p>
            </Col>
          </Col>
        </Row>
        <Container>
          <Row className="mb-5  text-center">
            <Col md={{ size: 4 }} className='pt-3'>
              <CardImg
                className="our-community-icons"
                top
                src="img/quality-learning-icon-v2.png"
                alt="Card image cap"
              />
              <h3 className="mt-4 text-center">
                High Quality Learning
                </h3>
              <hr className="about-us-card-line mt-1 mb-4" />
              <p>
                We offer world-class, affordable learning in full-stack coding, data science, cyber security and related digital tech skills.
                </p>
            </Col>
            <Col md={{ size: 4 }} className='pt-3'>
              <CardImg
                className="our-community-icons"
                top
                src="img/tools-to-succeed-icon-v2.png"
                alt="Card image cap"
              />
              <h3 className="mt-4 text-center">Tools to Succeed</h3>
              <hr className="about-us-card-line mt-1 mb-4" />
              <p>
                Our immersive software training program is designed to help you succeed in the evovling digital economy.
                </p>
            </Col>
            <Col md={{ size: 4 }} className='pt-3'>
              <CardImg
                className="our-community-icons"
                top
                src="img/relevant-curriculum-icon-v2.png"
                alt="Card image cap"
              />
              <h3 className="mt-4 text-center">
                Market Relevant Curriculum
                </h3>
              <hr className="about-us-card-line mt-1 mb-4" />
              <p>
                Designing curriculum with expert instructors to help you with the rapid changing work landscape.
                </p>
            </Col>
          </Row>
          <Row className="justify-content-center section-padding">
            <Col xs={{ size: 12 }} sm={{ size: 12 }} className="text-center">
              
              <div className='position-relative mb-1'>
                <h1 className="mt-5 mb-3 center-h1 course-path pb-2">
                  Our Dedicated Instructors
                </h1>
              </div>
              {/* <hr className="heading-underline mb-5" /> */}
              <p className="mb-5">
                Meet our wonderful and awesome instructional team! Our instructional team come from years of experience in their industry and have a strong passion and experience in teaching students to reach their goals and build their skills to stay relevant, forever.
              </p>
            </Col>
          </Row>
          <Row className="pt-md-0 justify-content-center text-center">
            <Col xs={{ size: 6 }} sm={{ size: 2 }} className="pb-5 pb-md-0">
              <CardImg
                className="instructors-png"
                top
                src="img/instructors-jess-v2.png"
                alt="Card image cap"
              />
              <h3 className="mt-1">Jess</h3>
              <p>
                Data Scientist
              </p>
            </Col>
            <Col xs={{ size: 6 }} sm={{ size: 2 }} className="pb-5 pb-md-0">
              <CardImg
                className="instructors-png"
                top
                src="img/testimonial-mannex-v2.png"
                alt="Card image cap"
              />
              <h3 className="mt-1">Mannex</h3>
              <p>
                Full Stack Web Developer
              </p>
            </Col>
            <Col xs={{ size: 6 }} sm={{ size: 2 }} className="pb-5 pb-md-0">
              <CardImg
                className="instructors-png"
                top
                src="img/testimonial-kelley-v2.png"
                alt="Card image cap"
              />
              <h3 className="mt-1">Kelley</h3>
              <p>
                UX Designer
              </p>
            </Col>
            <Col xs={{ size: 6 }} sm={{ size: 2 }} className="pb-5 pb-md-0">
              <CardImg
                className="instructors-png"
                top
                src="img/instructors-sonja-v2.png"
                alt="Card image cap"
              />
              <h3 className="mt-1">Sonja</h3>
              <p>
                Digital Marketer
              </p>
            </Col>
          </Row>
          <Row className="justify-content-center section-padding">
            <Col xs={{ size: 12 }} sm={{ size: 12 }} className="text-center">
              <div className='position-relative'>
                <h1 className="mt-5 mb-3 center-h1 course-path pb-2">
                  Preparing Talent For Top Companies
                </h1>
              </div>
              
              {/* <hr className="heading-underline mb-5" /> */}
            </Col>
          </Row>
          <Row>
            <Col>
              <CardImg
                className='d-none d-md-block'
                top
                height="100%"
                src="img/industry-partners-v2.png"
                alt="Card image cap"
              />
              <CardImg
                className='d-md-none'
                top
                height="100%"
                src="img/m-industry-partners-v2.png"
                alt="Card image cap"
              />
            </Col>
          </Row>
        </Container>
        <QuestionForm
          title={'Have Questions?'}
          textTitle={'We’d love to help you out!'}
          text={'Schedule a call with one of our Student Advisors. From curriculum to payment plans - our experts are happy to help.'}
        />
      </div>
    );
  }
}

export default AboutUsPage;
